import * as React from 'react'

function DocumentIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.552 8.552l-3.77-3.77c-.5-.5-1.179-.782-1.886-.782H9.333a2.667 2.667 0 00-2.666 2.667v18.666A2.667 2.667 0 009.333 28h13.334a2.667 2.667 0 002.666-2.667V10.437c0-.707-.28-1.385-.781-1.885v0zM10.667 16.307h10.666M10.667 20.307h10.666M10.667 24h6.666"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.667 11.001V9c0-.552.446-.999.998-.999h2.003c.552 0 .999.447.999.999V11a.999.999 0 01-.999.999h-2.003a.999.999 0 01-.998-.999z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { DocumentIcon }
